module.exports = __webpack_public_path__ + "themes/non-default/vennProvidedLogoGreyscale.d6e26cda31acdebd73700769d5ea7590.png";